
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization, getApiWithoutAuthorization, postApiWithAuthorization } from "../ApiMethod/ApiMethod";

const Prasadurl = `${BaseUrl}/Prasad`

export const PrasadCategoryLookupList = async () => {

    const url = `${Prasadurl}/PrasadCategoryLookupList`;
    const res = await getApiWithAuthorization(url);
    return res;
};
export const PrasadDataList = async (params, prasadID, userID) => {
    const url = `${Prasadurl}/PrasadList?PrasadCatID=${prasadID}&USER_ID=${userID}`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const Prasad_Cart = async (params) => {
    const url = `${Prasadurl}/Prasad_Cart`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const Prasad_CartList = async (params, USER_ID) => {
    const url = `${Prasadurl}/Prasad_CartList?USER_ID=${USER_ID}`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const Prasad_Order = async (params) => {
    const url = `${Prasadurl}/Prasad_Order`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const PrasadListBySlug = async (Slug) => {
    const url = `${Prasadurl}/PrasadListBySlug?Slug=${Slug}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
export const PrasadOrderList = async (param, USER_ID) => {
    const url = `${Prasadurl}/PrasadOrderList?USER_ID=${USER_ID}`;
    const res = await postApiWithAuthorization(url, param);
    return res;
};
export const PrasadOrderDetail = async (param, USER_ID) => {
    const url = `${Prasadurl}/PrasadOrderDetails?ORDER_ID=${USER_ID}`;
    const res = await postApiWithAuthorization(url, param);
    return res;
};

export const PrasadInvoicc = async (USER_ID, OrderID) => {
    const url = `${BaseUrl}/PrasadInvoicc?USER_ID=${USER_ID}&OrderID=${OrderID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};